import { render, staticRenderFns } from "./MmStates.vue?vue&type=template&id=2b117018&scoped=true"
import script from "./MmStates.vue?vue&type=script&lang=ts"
export * from "./MmStates.vue?vue&type=script&lang=ts"
import style0 from "./MmStates.vue?vue&type=style&index=0&id=2b117018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b117018",
  null
  
)

export default component.exports